/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs */

const en_admin_external_booking_edit_extra_price_per_day_item = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per item, per day`)
};

const de_admin_external_booking_edit_extra_price_per_day_item = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Einheit, pro Tag`)
};

const es_admin_external_booking_edit_extra_price_per_day_item = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por artículo, por día`)
};

const fr_admin_external_booking_edit_extra_price_per_day_item = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par article, par jour`)
};

const nl_admin_external_booking_edit_extra_price_per_day_item = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per stuk, per dag`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */
const it_admin_external_booking_edit_extra_price_per_day_item = en_admin_external_booking_edit_extra_price_per_day_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_extra_price_per_day_item = en_admin_external_booking_edit_extra_price_per_day_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */
const pl_admin_external_booking_edit_extra_price_per_day_item = en_admin_external_booking_edit_extra_price_per_day_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */
const hu_admin_external_booking_edit_extra_price_per_day_item = en_admin_external_booking_edit_extra_price_per_day_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs) => LocalizedString} */
const ro_admin_external_booking_edit_extra_price_per_day_item = en_admin_external_booking_edit_extra_price_per_day_item;

/**
* | output |
* | --- |
* | "per item, per day" |
*
* @param {Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_extra_price_per_day_item = /** @type {((inputs?: Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Extra_Price_Per_Day_ItemInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "de") return de_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "es") return es_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "it") return it_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_extra_price_per_day_item(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_extra_price_per_day_item(inputs)
	return ro_admin_external_booking_edit_extra_price_per_day_item(inputs)
});
export { admin_external_booking_edit_extra_price_per_day_item as "admin.external_booking_edit.extra_price_per_day_item" }